var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 20,
    viewBox: "0 0 60 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17145_19617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.123535 11.8307C0.123535 8.98776 2.45658 6.77832 5.48491 6.77832C7.24628 6.77832 8.8377 7.5663 9.76474 8.74055L8.45143 10.0539C7.7407 9.14227 6.65916 8.61695 5.51581 8.6015C3.70809 8.6015 2.25572 9.96115 2.25572 11.8307C2.25572 13.7157 3.70809 15.0753 5.51581 15.0753C6.70551 15.0753 7.83341 14.5191 8.54414 13.5612L9.84199 14.8436C8.9613 16.0796 7.29263 16.8985 5.48491 16.8985C2.45658 16.8985 0.123535 14.689 0.123535 11.8307Z",
    fill: "#255BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5571 7.11816H13.643V16.5585H11.5571V7.11816Z",
    fill: "#255BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5056 14.0242V8.86364H15.2344V7.11772H17.6138V5.09368L19.5606 4.13574V7.11772H22.6507V8.87909H19.5606V13.6842C19.5606 14.6422 20.1013 15.0593 21.1056 15.0593C21.6309 15.0593 22.1563 14.9512 22.6352 14.7349V16.5272C22.0327 16.7898 21.3837 16.9134 20.7194 16.9134C18.8653 16.898 17.5056 15.8937 17.5056 14.0242Z",
    fill: "#255BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2886 7.11816H26.3744V16.5585H24.2886V7.11816Z",
    fill: "#255BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9422 1.10753C22.4031 1.09208 25.6632 2.7762 27.6564 5.60366H25.2306C22.0941 2.12727 16.7482 1.84916 13.2718 4.97019C13.0555 5.17105 12.8392 5.38736 12.6383 5.60366H10.228C12.2212 2.7762 15.4812 1.09208 18.9422 1.10753Z",
    fill: "#FF3C28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17145_19617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9039,
    height: 18,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.0cbf59b29a95fb126d24f168ee1eaa7c.svg";
export { ForwardRef as ReactComponent };